import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { AccountService } from '@app/_services';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  
  constructor(
    private router: Router,
    private accountService: AccountService
  ) {}
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      const user = this.accountService.userValue;

      if (user) {

        if(route.data.roles) {
          const routeRoles: string[] = route.data.roles; // copy to set type explicitly
          const filteredRoles = routeRoles.filter(value => user.roles.includes(value))
          // Note: Removed console.log for security - user roles should not be logged in production
          if (filteredRoles.length <= 0) { // no intersection between user roles and required roles
            this.router.navigate(['/']);
            return false;
          }
        }
        return true;
      }

      this.router.navigate(['/account/login'], {queryParams: { returnUrl: state.url }});
      return false;
  }
  
}
